const status = [
  { id: 1, name: "Active" },
  { id: 2, name: "Inactive" },
  { id: 3, name: "Archived" },
];

export const campaignConstants = {
  status,
};

export const statusColors = {
  1: { color: "green", content: "Active" },
  2: { color: "grey", content: "Inactive" },
  3: { color: "red", content: "Archived" },
};
